import React from 'react';
import { SkeletonCell } from '../SkeletonCell';
import styled from 'styled-components';
import { Theme } from '../../utils/themes';
import { useTheme } from '../../middleware/ThemeContext';

interface TableSkeletonProps {
    rowCount?: number;
    columns: {
        name?: string | undefined;
        type?: 'text' | 'circle' | 'actions'; // Column type
        width?: string;
        height?: string;
        rounded?: boolean;
        actionsCount?: number; // only for actions type
    }[];
    roundedHeaders?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
    rowCount = 5,
    columns,
    roundedHeaders
}) => {
    const {theme} = useTheme();
    return (
        <table className="table table-responsive">
            <StyledHeader theme={theme}>
                <tr>
                    {columns.map((col, idx) => (
                        <th key={idx} className="align-middle px-4 text-center">
                            <SkeletonCell
                                height="34px"
                                rounded={roundedHeaders}
                            />
                        </th>
                    ))}
                </tr>
            </StyledHeader>
            <StyledTableBody theme={theme}>
                {[...Array(rowCount)].map((_, rowIdx) => (
                    <tr key={rowIdx}>
                        {columns.map((col, colIdx) => {
                            if (col.type === 'actions') {
                                return (
                                    <td key={colIdx} className="align-middle px-4 d-flex gap-2">
                                        {[...Array(col.actionsCount || 3)].map((_, i) => (
                                            <SkeletonCell
                                                key={i}
                                                width={col.width || '28px'}
                                                height={col.height || '28px'}
                                                rounded
                                            />
                                        ))}
                                    </td>
                                );
                            }

                            return (
                                <td key={colIdx} className="align-middle px-4 text-center">
                                    <SkeletonCell
                                        width={col.width || '100%'}
                                        height={col.height || '28px'}
                                    />
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </StyledTableBody>
        </table>
    );
};


const StyledHeader = styled.thead<{ theme: Theme }> `
 
  th {
      background: ${({ theme }) => theme?.CorporateTheme?.colors?.filterBG}; !important;
    color: ${({ theme }) => theme?.CorporateTheme?.colors?.headerColor} !important;
    border: none !important;
    padding: 10px; /* optional: thoda spacing */
    // text-align: center; /* optional: alignment */
    font-weight: 600;
    font-size: 13px;
    font-family: var(--font-raleway);
  }
`;

const StyledTableBody = styled.tbody<{ theme: Theme }> `
 
  td {
      background: transparent !important;
    color: ${({ theme }) => theme?.CorporateTheme?.colors?.headerColor} !important;
 
  }
`;


export default TableSkeleton;
